import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Category as SchemaCategory } from '../schemas/Category';
import { type NewCategory as SchemaNewCategory } from '../schemas/NewCategory';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Categories
 */
export const CreateCategoryContentType = 'application/json' as const;
export type CreateCategoryRequest = SchemaNewCategory;
export type CreateCategoryResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaCategory;
    };
};
export type CreateCategoryResponseSuccess = CreateCategoryResponses['200']['application/json'];
export type CreateCategorySearchParams = undefined;
export type CreateCategoryPathParameters = undefined;
export const CreateCategoryUrl = '/categories' as const;
export const CreateCategoryMethod = 'POST' as const;
export const getCreateCategoryUrl = (_params?: CreateCategoryPathParameters) => CreateCategoryUrl;
